import { render, staticRenderFns } from "./CategoriesFilter.vue?vue&type=template&id=d980c862&lang=pug"
import script from "./CategoriesFilter.vue?vue&type=script&lang=js"
export * from "./CategoriesFilter.vue?vue&type=script&lang=js"
import style0 from "./CategoriesFilter.vue?vue&type=style&index=0&id=d980c862&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports